<template>
  <div id="service" v-bind:class="{ asiaService: southEstAsiaMode }">
    <nav class="switch-types" v-if="southEstAsiaMode">
      <a
        class="switch-type"
        v-if="southEstAsiaMode"
        :class="{ active: showService }"
        @click="switchType('serviceContract')"
      >
        {{ languages.termsOfUse }}
      </a>
      <a
        class="switch-type"
        v-if="southEstAsiaMode"
        :class="{ active: !showService }"
        @click="switchType('userContract')"
      >
        {{ languages.privacyPolicy }}
      </a>
      <!-- <a class="switch-type " v-if="!southEstAsiaMode" :class="{active:showService}" >{{languages.termsOfUse}}</a>
            <a class="switch-type " v-if="!southEstAsiaMode" :class="{active:!showService}" >{{languages.privacyPolicy}}</a> -->
    </nav>
    <article class="service-content">
      <iframe
        class="service-content-iframe"
        :src="serviceHref"
        @load="onIframeLoad"
      ></iframe>
    </article>
  </div>
</template>
<script>
import {
  SERVICE_TERM_URL,
  PRIVICY_TERM_URL,
  SOUTHEST_ASIA_MODE,
} from '../../utiles';
import globalConfig from '../../utiles/globalConfig';
import bridge from '../../utiles/bridge';
const SERVICE_CONTECT = 'serviceContract';
const USER_CONTECT = 'userContract';
const SHOW_NEXT_PROTOTCOL = 'showNextProtocol';
const VIEW_PROTOCOL_FINISH = 'viewProtocolFinish';
const PROTOCOL_LIST = [SERVICE_CONTECT, USER_CONTECT];
let showIndex = 0;
const USER_MODE = globalConfig.getHrefParam('userMode');
const search = globalConfig.getLocationSearch();

export default {
  data() {
    return {
      showService: true,
      serviceHref: SERVICE_TERM_URL + search,
      southEstAsiaMode: USER_MODE == SOUTHEST_ASIA_MODE,
    };
  },
  computed: {
    languages() {
      return this.$store.state.passport.languages;
    },
  },
  methods: {
    onIframeLoad(event) {
      /*
                （1）东南亚模式，sdk 点击确定，前端立即 调用浏览完毕操作
                （2）欧美模式，sdk 点击 确定，前端现实下一个协议
                （3）欧美模式， 当前已经显示完 所有协议的时候，回调sdk 浏览完毕的功能。
            */
      bridge.registHandler(SHOW_NEXT_PROTOTCOL, () => {
        if (this.southEstAsiaMode || showIndex >= PROTOCOL_LIST.length - 1) {
          bridge.callSdkMethod(VIEW_PROTOCOL_FINISH);
        } else {
          showIndex += 1;
          let nextProtocol = PROTOCOL_LIST[showIndex];
          this.switchType(nextProtocol);
        }
      });
    },
    switchType(type) {
      switch (type) {
        case SERVICE_CONTECT:
          {
            this.showService = true;
            this.serviceHref = SERVICE_TERM_URL + search;
            // this.serviceContent = terms;
          }
          break;
        case USER_CONTECT:
          {
            this.showService = false;
            this.serviceHref = PRIVICY_TERM_URL + search;
            // this.serviceContent = userAgreement;
          }
          break;
      }
    },
  },
};
</script>

<style lang="scss">
@import '../../assets/scss/base.scss';
@import '../../assets/scss/platform-base.scss';
#service {
  position: relative;
  height: 100%;
  width: 100%;
  box-sizing: border-box;
  background-color: #f5f5f5;
  padding: 10px;
  // padding-top:95px;
}
$activeH: 65px;
.switch-types {
  position: absolute;
  top: 10px;
  width: 100%;
  height: $activeH;
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
}
.switch-type {
  $normalH: 50px;
  display: block;
  float: left;
  width: 345px;
  font-size: 24px;
  color: black;
  height: 100%;
  line-height: $activeH;
  text-align: center;
  background: #e2e2e2;
  &.active {
    background: white;
    color: #0596ff;
  }
}

.service-content {
  width: 100%;
  height: 100%;
  float: left;
  box-sizing: border-box;
  // line-height: 32px;
  // font-size: 24px;
  // color:black;
  padding-top: 0;
  padding-bottom: 0;
  background: white;
}

.service-content-iframe {
  height: 100%;
  width: 100%;
}

.asiaService {
  padding-top: 95px !important;
}

@media screen and (orientation: landscape) {
  //横屏
  .switch-type {
    width: 610px !important;
  }
  .service-content {
    margin-top: 8px;
  }
}
</style>
